import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';


const routes: CustomRoute = {
	path: '/copyright',
	components: () => [],
	render: (_, children) => children,
	onEnter: async () => {},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'Copyright' */ './component')],
			render: ([Copyright]) => <Copyright />,
			onEnter: async ({ next }) => {
				console.log('on Enter Copyright');
				await next();
				console.log('on Enter Copyright / end');
			},
		},
	],
};

export default routes;
